import {
    FETCH_PATIENT_PORTAL_ENCOUNTER_SYNC_SUCCESS,
    RESET_PATIENT_PORTAL_ENCOUNTER_SYNC,
} from './patientPortalEncounterSync-actions';
import initialStates from '../../initialStates';

const patientPortalEncounterSyncReducer = (state = initialStates.patientPortalEncounterSync, action) => {
    switch (action.type) {
    case FETCH_PATIENT_PORTAL_ENCOUNTER_SYNC_SUCCESS:
        return {
            list: action.data.content,
            first: action.data.first,
            last: action.data.last,
            forwardSeekMap: action.data.forwardSeekMap,
            backwardSeekMap: action.data.backwardSeekMap,
            page: action.page,
            size: action.size,
            filters: action.filters,
        };

    case RESET_PATIENT_PORTAL_ENCOUNTER_SYNC:
        return initialStates.patientPortalEncounterSync;

    default:
        return state;
    }
};

export default patientPortalEncounterSyncReducer;
